import { Button } from '$components'
import { useCreateCoatTypeForm } from './index'

export function CreateCoatTypeFormControls() {
  const { onCancel, isLoading } = useCreateCoatTypeForm()

  return (
    <div className="flex gap-4 mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Button
        isLoading={isLoading}
        type="submit"
        size="lg"
      >
        Create Coat Type
      </Button>
    </div>
  )
}
